export enum ConfigManagerProperties {
  buildVersion = 'buildVersion',
  production = 'production',
  apiUrl = 'apiUrl',
  region = 'region',
  shippingToolsApiService = 'shippingtoolsApiEndpoint',
}
